import { render, staticRenderFns } from "./ResellerTickets.vue?vue&type=template&id=6e88473d&scoped=true&"
import script from "./ResellerTickets.vue?vue&type=script&lang=js&"
export * from "./ResellerTickets.vue?vue&type=script&lang=js&"
import style0 from "./ResellerTickets.vue?vue&type=style&index=0&id=6e88473d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e88473d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDataTable,VIcon,VRow,VSelect,VSpacer,VTextField})
